import { alpha, createTheme } from "@mui/material/styles";

const colors = {
  ink: "#18241D",
  forest: "#244A38",
  moss: "#71836B",
  clay: "#B8673E",
  sand: "#DCCBB6",
  ivory: "#F7F3EC",
  paper: "#FFFDF8",
};

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: colors.forest, dark: "#183326", contrastText: "#FFFFFF" },
    secondary: { main: colors.clay, dark: "#934B2B", contrastText: "#FFFFFF" },
    background: { default: colors.ivory, paper: colors.paper },
    text: { primary: colors.ink, secondary: "#5F685F" },
    divider: alpha(colors.ink, 0.12),
    success: { main: "#52715C" },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", sans-serif',
    h1: { fontFamily: '"DM Serif Display", Georgia, serif', fontWeight: 400, letterSpacing: "-0.035em" },
    h2: { fontFamily: '"DM Serif Display", Georgia, serif', fontWeight: 400, letterSpacing: "-0.025em" },
    h3: { fontFamily: '"DM Serif Display", Georgia, serif', fontWeight: 400, letterSpacing: "-0.02em" },
    h4: { fontFamily: '"DM Serif Display", Georgia, serif', fontWeight: 400 },
    h5: { fontWeight: 700, letterSpacing: "-0.015em" },
    h6: { fontWeight: 700, letterSpacing: "-0.01em" },
    button: { textTransform: "none", fontWeight: 700, letterSpacing: "0.01em" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundImage: "radial-gradient(circle at 15% 10%, rgba(220,203,182,.22), transparent 28%)" },
        "::selection": { backgroundColor: colors.sand, color: colors.ink },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { minHeight: 44, borderRadius: 999, paddingInline: 22 },
        containedPrimary: { boxShadow: "0 10px 24px rgba(36,74,56,.18)", "&:hover": { boxShadow: "0 14px 30px rgba(36,74,56,.26)" } },
      },
    },
    MuiCard: {
      styleOverrides: { root: { backgroundImage: "none", border: `1px solid ${alpha(colors.ink, 0.09)}`, boxShadow: "0 18px 50px rgba(35,45,37,.08)" } },
    },
    MuiTextField: { defaultProps: { variant: "outlined" } },
    MuiOutlinedInput: {
      styleOverrides: { root: { backgroundColor: alpha(colors.paper, 0.9), "& fieldset": { borderColor: alpha(colors.ink, 0.16) }, "&:hover fieldset": { borderColor: colors.moss } } },
    },
    MuiIconButton: { styleOverrides: { root: { minWidth: 44, minHeight: 44 } } },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 20 } } },
  },
});

export default theme;
